// extracted by mini-css-extract-plugin
export var avatarContainer = "_4v-0";
export var avatarTypingWave = "_4v-i";
export var gray = "_4v-f";
export var green = "_4v-c";
export var icon = "_4v-9";
export var image = "_4v-1";
export var lg = "_4v-6";
export var md = "_4v-5";
export var presenceDot = "_4v-b";
export var red = "_4v-d";
export var sm = "_4v-4";
export var status = "_4v-a";
export var typingDot = "_4v-h";
export var typingPill = "_4v-g";
export var xl = "_4v-7";
export var xs = "_4v-3";
export var xxl = "_4v-8";
export var xxs = "_4v-2";
export var yellow = "_4v-e";